import apiClient from '../../../lib/axios';

export interface TemplateComponent {
  type: string;
  text?: string;
  format?: string;
  buttons?: TemplateButton[];
  example?: Record<string, unknown>;
}

export interface TemplateButton {
  type: string;
  text: string;
  url?: string;
  phone_number?: string;
}

export interface MessageTemplate {
  id: string;
  name: string;
  status: string;
  language: string;
  category: string;
  components: TemplateComponent[];
  quality_score?: { score: string; date: number };
}

export interface TemplateListResponse {
  data: MessageTemplate[];
  paging?: {
    cursors?: { before: string; after: string };
    next?: string;
  };
}

export interface CreateTemplatePayload {
  name: string;
  language: string;
  category: string;
  parameter_format?: 'named' | 'positional';
  components: Record<string, unknown>[];
  message_send_ttl_seconds?: number;
}

export interface UpdateTemplatePayload {
  components: Record<string, unknown>[];
  message_send_ttl_seconds?: number;
}

export const templatesApi = {
  list: (params?: { status?: string; limit?: number }) =>
    apiClient.get<TemplateListResponse>('/v1/message-templates', { params }),

  create: (data: CreateTemplatePayload) =>
    apiClient.post<{ id: string; status: string }>('/v1/message-templates', data),

  update: (templateId: string, data: UpdateTemplatePayload) =>
    apiClient.put(`/v1/message-templates/${templateId}`, data),

  upload: (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    return apiClient.post<{ handle: string }>('/v1/message-templates/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  remove: (name: string) =>
    apiClient.delete(`/v1/message-templates/${encodeURIComponent(name)}`),
};
